import { render } from "./CourseCreationProcess.vue?vue&type=template&id=6fbe5d88&scoped=true"
import script from "./CourseCreationProcess.vue?vue&type=script&lang=js"
export * from "./CourseCreationProcess.vue?vue&type=script&lang=js"

import "./CourseCreationProcess.vue?vue&type=style&index=0&id=6fbe5d88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbe5d88"]])

export default __exports__